/**
 * Plugin Scripts Entrypoint.
 *
 * This file serves as a place to import all of the JS that will eventually be bundled by Webpack to form the production-ready version.
 *
 * @author Nick Patterson <nick@fifteen4.com>
 */

/** Dependencies -------------------------------------------- */

// Internal

import olbLoginAlert from './includes/olb-login-alert'

/** Initialization ------------------------------------------ */

function onDomContentLoaded() {

    olbLoginAlert.init( { selector: '[data-olb-login-alert]' } )

}

function onPageShow() {

}

if ( document.readyState !== 'loading' ) {
    onDomContentLoaded()
}
else {
    window.addEventListener( 'DOMContentLoaded', onDomContentLoaded )
}

window.addEventListener( 'pageshow', onPageShow )
